import { Radio, RadioProps } from 'antd';

export type AppRadioProps = RadioProps;

export const AppRadio = ({ ...props }: AppRadioProps) => <Radio {...props} />;
